"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notInitialized = void 0;
function notInitialized() {
    throw new Error('Callback is not initialized');
}
exports.notInitialized = notInitialized;
